var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"margin":"20px"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.addListBtn}},[_vm._v("新增訂單")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }